import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ModalService } from '@services/modal.service';
import { SecurityContextService } from '@services/security_context.service';

@Component({
  selector: 'sidebar',
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.less',
})
export class SidebarComponent implements OnInit {
  // Constants
  firstname = '';
  lastname = '';
  user: any = undefined;

  constructor(
    public _router: Router,
    private _modalService: ModalService,
    private _securityContextService: SecurityContextService,
  ) {}

  // Lifecycle Hooks
  ngOnInit(): void {
    homer(); // This runs a bunch of jquery to make the sidebar a jquery metismenu
    this.user = this._securityContextService.authData();
    this.firstname = this.user?.firstname || '';
    this.lastname = this.user?.lastname || '';
  }

  // Functions
  logout = () => {
    this._securityContextService.logOut();
    this._router.navigate(['/login']);
  };

  isFreemium = () => {
    const u = this._securityContextService.authData();
    if (u) {
      return u.accounttype == 6;
    } else {
      return false;
    }
  };

  isFranchise = (franchise: string) => {
    if (this._securityContextService.authData().franchisecode != null) {
      return this._securityContextService.authData().franchisecode == franchise;
    } else {
      return false;
    }
  };

  workshopAccounts = async () => {
    try {
      const response = await this._modalService.open('workshopAccounts', {});
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  setupWorkshopAccounts = async () => {
    try {
      const response = await this._modalService.open(
        'workshopAccountSetup',
        {},
      );
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  workshopPasswords = async () => {
    try {
      const response = await this._modalService.open('workshopPasswords', {});
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };
}
